import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./AddLesson.module.scss";
import { CloseIcon } from "Assets/icons";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { Formik } from "formik";
import sendIntakeSchema from "./sendIntakeSchema";
import { RequiredFieldAstrick } from "components/Common/Common";

const SendIntakePop = ({ show, setShow, submitHandler, heading = "" }) => {

    const handlePopup = () => {

        setShow(!show);
    };

    const handleSubmit = (values) => {
        typeof submitHandler == "function" && submitHandler(values);
    };

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Formik
                    initialValues={{ email: "" }}
                    validationSchema={sendIntakeSchema}
                    onSubmit={handleSubmit}
                >
                    {({ handleSubmit }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                                <Button
                                    onClick={handlePopup}
                                    className="border-0 p-0 position-absolute"
                                    variant="transparent"
                                    style={{ right: 10, top: 0 }}
                                >
                                    <CloseIcon />
                                </Button>
                                <div>
                                    <h6 className="m-0 fw-bold themeBlue">{heading}</h6>

                                </div>
                                <Row>
                                    <Col className="col-12 my-4">
                                        <label
                                            htmlFor=""
                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                        >
                                            Email
                                            <RequiredFieldAstrick />
                                        </label>
                                        <AppInputField
                                            className="form-control"
                                            type="text"
                                            name="email"
                                            placeholder="Email"
                                        />
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer className="justify-content-center flex-column">
                                <Button
                                    type="submit"
                                    className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                >
                                    Send

                                </Button>
                            </Modal.Footer>
                        </Form>
                    )
                    }
                </Formik>
            </Modal >
        </>
    );
};

export default SendIntakePop;



const searchIcn = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2621 15.5737L9.27139 10.8843C8.81306 11.2627 8.28598 11.5589 7.69014 11.7728C7.09431 11.9867 6.47793 12.0936 5.841 12.0936C4.27426 12.0936 2.9483 11.5512 1.86312 10.4663C0.777942 9.38144 0.235352 8.05579 0.235352 6.48936C0.235352 4.92308 0.777789 3.59697 1.86266 2.51103C2.94754 1.42524 4.27319 0.882339 5.83962 0.882339C7.4059 0.882339 8.73201 1.42493 9.81796 2.51011C10.9037 3.59529 11.4466 4.92125 11.4466 6.48799C11.4466 7.14264 11.3368 7.76788 11.1171 8.36372C10.8973 8.95955 10.604 9.47777 10.2373 9.91838L15.228 14.6076L14.2621 15.5737ZM5.841 10.7189C7.02212 10.7189 8.02251 10.309 8.84216 9.48915C9.66197 8.6695 10.0719 7.66911 10.0719 6.48799C10.0719 5.30686 9.66197 4.30647 8.84216 3.48682C8.02251 2.66701 7.02212 2.25711 5.841 2.25711C4.65987 2.25711 3.65948 2.66701 2.83983 3.48682C2.02003 4.30647 1.61012 5.30686 1.61012 6.48799C1.61012 7.66911 2.02003 8.6695 2.83983 9.48915C3.65948 10.309 4.65987 10.7189 5.841 10.7189Z" fill="#1C1B1F" />
</svg>


const serviceOptions = [
    {
        value: "",
        label: "All Services",
    },
    {
        value: "school",
        label: "School",
    },
    {
        value: "home_education",
        label: "Home Education",
    },
    {
        value: "chatter",
        label: "Chatter",
    },
    {
        value: "private",
        label: "Private",
    }
];